import React from "react";

const BlogAuthor = ({ founderImage, founderName, blogId }) => {
  return (
    <div className="blogger-div">
      <img src={founderImage} className="blogger-image" alt="blogger" />
      <p className="blogger-name">{founderName}</p>

      {blogId === "analytical-proficiency" && (
        <a
          href="https://www.linkedin.com/pulse/importance-being-fluent-language-data-data-driven-era-khandelwal-t0rlc/?trackingId=VLJ9DTCyQ4OeU1193scT1w%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          className="linkedin-link"
        >
          Originally Posted on LinkedIn
        </a>
      )}
    </div>
  );
};

export default BlogAuthor;
